import { Country } from 'company/domain/country'
import { ICountryRepository } from 'company/domain/ICountryRepository'

export class ListCountryUseCase {
    private countryRepository: ICountryRepository

    constructor(countryRepository: ICountryRepository) {
        this.countryRepository = countryRepository
    }

    async execute(): Promise<Country[]> {
        return await this.countryRepository.get()
    }
}
